<div class="card">
  <div class="card-header">
    <strong translate>Settings</strong>
  </div>
  <div class="card-body">
    @if (isLoading) {
      <div class="d-flex align-items-center">
        <span class="fa-solid fa-spinner fa-spin me-2" aria-hidden="true"></span>
        <span translate>Loading organization settings</span>
      </div>
    } @else {
      <form #settingsForm="ngForm" (ngSubmit)="saveSettings()">
        <div class="form-group">
          <label for="dashboardPollingInterval">
            <span translate>Dashboard live data polling interval</span>
            <span class="text-muted">(<span translate>seconds</span>)</span>
          </label>
          <input
            [(ngModel)]="pollingIntervalInSeconds"
            [disabled]="!settingsLoaded || !canEdit || isSaving"
            class="form-control"
            id="dashboardPollingInterval"
            [min]="minPollingIntervalSeconds"
            [max]="maxPollingIntervalSeconds"
            name="dashboardPollingInterval"
            required
            type="number">
          <small class="form-text text-muted" translate>
            Defines how often live data is requested for machines shown in the dashboard list view.
          </small>
          @if (!isValidPollingInterval()) {
            <div class="invalid-feedback d-block" translate>
              The polling interval must be between {{minPollingIntervalSeconds}} seconds and {{maxPollingIntervalMinutes}} minutes.
            </div>
          }
        </div>

        @if (canEdit) {
          <button [disabled]="!settingsLoaded || settingsForm.invalid || !isValidPollingInterval() || isSaving"
            class="btn btn-primary"
            type="submit">
            @if (isSaving) {
              <span class="fa-solid fa-spinner fa-spin me-1" aria-hidden="true"></span>
            }
            <span translate>Save</span>
          </button>
        }
      </form>
    }
  </div>
</div>
